@use 'variables' as *;
@use 'mixins' as *;

:host {
  display: flex;
  flex-direction: row;
  box-shadow: inset 0 -1px 0 0 cat-token('color.ui.border.default');
}

:host([hidden]) {
  display: none;
}

:host([tabs-align='center']) {
  .cat-tab-list {
    justify-content: center;
  }
}

:host([tabs-align='right']) {
  .cat-tab-list {
    justify-content: end;
  }
}

:host([tabs-align='justify']) {
  cat-button {
    flex: 1 0 auto;
  }
}

.cat-tab,
.cat-tab-more-button {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
  transition: none;

  &::after {
    opacity: 0;
    content: '';
    position: absolute;
    background: currentColor;
    left: 0.75rem;
    right: 0.75rem;
    bottom: 0;
    height: 2px;
  }

  &:hover::after {
    opacity: 0.25;
  }

  &.cat-tab-active {
    font-weight: 700;
    color: cat-token('color.theme.primary.textActive');
  }

  &.cat-tab-active::after {
    opacity: 1;
  }
}

.cat-tab {
  &:first-of-type {
    margin-left: -0.75rem;
  }

  &:last-of-type {
    margin-right: -0.75rem;
  }

  &.cat-tab-error {
    color: cat-token('color.theme.danger.textActive');
  }
}

nav {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}

.cat-tab-list {
  display: flex;
  width: 100%;
}
